const MutipleChoiceQuestion = ({ question, answerChoices, responses, saveResponse, compact }) => {

    const onMultipleChoiceRadioChange = (value) => {
        const params = {
            surveyQuestionId: question.surveyQuestionId,
            questionId: question.questionId,
            multipleChoiceAnswerId: parseInt(value, 10)
        }
        saveResponse(params);
    }

    const onMultipleChoiceCheckboxChange = (value, checked) => {
        console.log(`value: ${value} checked: ${checked}`);
        const params = {
            surveyQuestionId: question.surveyQuestionId,
            questionId: question.questionId,
            multipleChoiceAnswerId: parseInt(value, 10),
            checked: checked
        }
        saveResponse(params);
    }

    const onMultipleChoiceSelectChange = (value) => {
        console.log(`value: ${value}`);
        const params = {
            surveyQuestionId: question.surveyQuestionId,
            questionId: question.questionId,
            multipleChoiceAnswerId: parseInt(value, 10)
        }
        saveResponse(params);
    }

    if ((question.type === "select") && (compact !== true)) {
        let value = undefined;
        if (responses.length > 0) {
            value = responses[0].multipleChoiceAnswerId;
        }
        return (
            <div className="multiple-choice">
                <select className={compact ? "compact" : ""} value={value} onChange={(e) => onMultipleChoiceSelectChange(e.target.value)}>
                    {
                        answerChoices.map((answerChoice, i) => {
                            return (
                                <option key={i} value={answerChoice.multipleChoiceAnswerId}>{answerChoice.text}</option>
                            )
                        })
                    }
                </select>
            </div>
        )
    } else if (question.type === "checkbox") {
        return (
            <div className="multiple-choice">
                {
                    answerChoices.map((answerChoice, i) => {
                        let checked = false;
                        for (let response of responses) {
                            if (response.multipleChoiceAnswerId === answerChoice.multipleChoiceAnswerId) {
                                checked = true;
                                break;
                            }
                        }
                        return (
                            <div key={i} className="checkbox-and-label">
                                <input type="checkbox" id={answerChoice.multipleChoiceAnswerId} name={answerChoice.multipleChoiceAnswerId} value={answerChoice.multipleChoiceAnswerId} checked={checked} onChange={(e) => onMultipleChoiceCheckboxChange(e.target.value, e.target.checked)} />
                                <label className={compact ? "compact" : ""} htmlFor={answerChoice.multipleChoiceAnswerId}>{answerChoice.text}</label>
                            </div>
                        )
                    })
                }
            </div>
        )
    } else if ((question.type === "radio") || ((question.type === "select") && (compact === true))) {
        return (
            <div  className={`${compact ? "compact" : ""} multiple-choice`}>
                {
                    answerChoices.map((answerChoice, i) => {
                        let checked = false;
                        for (let response of responses) {
                            if (response.multipleChoiceAnswerId === answerChoice.multipleChoiceAnswerId) {
                                checked = true;
                                break;
                            }
                        }
                        return (
                            <div key={i} className="radio-button-and-label">
                                <input type="radio" id={answerChoice.multipleChoiceAnswerId} name={`question-${question.questionId}`} value={answerChoice.multipleChoiceAnswerId} checked={checked} onChange={(e) => onMultipleChoiceRadioChange(e.target.value)} />
                                <label className={compact ? "compact" : ""} htmlFor={answerChoice.multipleChoiceAnswerId}>{answerChoice.text}</label>
                            </div>
                        )
                    })
                }
            </div>
        )
    } else {
        return null;
    }
};

export default MutipleChoiceQuestion;